import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class InnBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.INN;
}

export default InnBuildingTileEntity;
